import { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { listTransactions, type PortalTransaction } from '../api';
import { revisionsOf, workspaceOf } from '../workspace';
import { usePortalWorkspaceRefresh } from '../workspace-refresh';

export function ActivityPage() {
  const [items, setItems] = useState<PortalTransaction[]>([]);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(() => {
    return listTransactions()
      .then((result) => {
        setItems(result.data);
        setError(null);
      })
      .catch((caught: unknown) => {
        setError(caught instanceof Error ? caught.message : 'Could not load activity.');
      });
  }, []);

  usePortalWorkspaceRefresh(load, {
    processingState: items.some((item) => workspaceOf(item).evidenceProcessing.state !== 'IDLE') ? 'FINALIZING' : 'IDLE',
    revisions: revisionsOf(items),
  });

  return (
    <>
      <p className="eyebrow">Activity</p>
      <h1>Activity</h1>
      <p className="lede">This is the same PackProof timeline source as the mobile app, not a second event log.</p>
      {error ? <p className="error">{error}</p> : null}
      <section className="stack">
        {items.map((item) => {
          const next = workspaceOf(item).nextAction;
          return (
            <Link key={item.id} className="card" to={`/packproofs/${item.id}/activity`} style={{ textDecoration: 'none', color: 'inherit' }}>
              <h2>{item.title}</h2>
              <p className="meta">{next?.headline ?? item.status.replaceAll('_', ' ')}</p>
              <p className="meta">Updated {item.updatedAt}</p>
            </Link>
          );
        })}
      </section>
      {!items.length && !error ? <p className="meta">No PackProof activity yet.</p> : null}
    </>
  );
}
